/* DateNormalize
 * Central utility for normalizing date strings to YYYY-MM-DD.
 * Handles all formats seen across the codebase:
 *   - YYYY-MM-DD        (ISO, preferred)
 *   - MM/DD/YYYY        (US format from metafields/properties)
 *   - YYYY-MM-DDTHH:MM:SSZ  (Shopify datetime metafield)
 *   - "Mar 4, 2026"     (human readable)
 */

if (!window.DateNormalize) {

  const DateNormalize = {

    /**
     * Normalize any date string to YYYY-MM-DD.
     * Returns null if unparseable.
     * @param {string} input
     * @returns {string|null}
     */
    toISO(input) {
      if (!input) return null;
      const s = String(input).trim();

      // Already YYYY-MM-DD or YYYY-MM-DDTHH...
      const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (iso) return `${iso[1]}-${iso[2]}-${iso[3]}`;

      // MM/DD/YYYY
      const us = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
      if (us) {
        const m = us[1].padStart(2, '0');
        const d = us[2].padStart(2, '0');
        return `${us[3]}-${m}-${d}`;
      }

      // M/D/YY (rare but seen)
      const usShort = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2})$/);
      if (usShort) {
        const m = usShort[1].padStart(2, '0');
        const d = usShort[2].padStart(2, '0');
        const y = parseInt(usShort[3], 10) + 2000;
        return `${y}-${m}-${d}`;
      }

      // "Mar 4, 2026" or "March 4, 2026"
      const months = {
        jan:1,feb:2,mar:3,apr:4,may:5,jun:6,
        jul:7,aug:8,sep:9,oct:10,nov:11,dec:12
      };
      const human = s.match(/^([A-Za-z]+)\s+(\d{1,2}),?\s+(\d{4})/);
      if (human) {
        const mo = months[human[1].slice(0,3).toLowerCase()];
        if (mo) {
          const m = String(mo).padStart(2, '0');
          const d = human[2].padStart(2, '0');
          return `${human[3]}-${m}-${d}`;
        }
      }

      return null;
    },

    /**
     * Format YYYY-MM-DD as MM/DD/YYYY for display.
     * @param {string} iso
     * @returns {string}
     */
    toDisplay(iso) {
      const normalized = this.toISO(iso);
      if (!normalized) return iso || '';
      const [y, m, d] = normalized.split('-');
      return `${m}/${d}/${y}`;
    },

    /**
     * Normalize an array of date strings to YYYY-MM-DD, filtering nulls.
     * @param {Array} arr
     * @returns {Array}
     */
    normalizeArray(arr) {
      if (!Array.isArray(arr)) return [];
      return arr.map(d => this.toISO(d)).filter(Boolean);
    }

  };

  window.DateNormalize = DateNormalize;

} // end guard
